export const BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";
export const POSTS_URL = "/posts";
export const USERS_URL = "/user";
export const COMMENTS_URL = "/comment";
export const MESSAGES_URL = "/message";
export const SEARCH_URL = "/search";
export const AUTH_URL = "/auth";
